<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title")
    b-container(fluid)
      b-row.search-form(align-h="between")
        b-col
          .d-flex.align-items-center
            b-form-select.mr-2(v-model="tableData.pagination.search_key" :options="selectOptions.list" size="sm" style="width: 100px" @change="changeSearchSelect")
            b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="tableData.pagination.search_value" @keyup.enter="search" size="sm" style="width: 150px")
            b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="tableData.pagination.search_value" :options="selectInput.list" size="sm" style="width: 150px" @change="search")
            b-btn(size="sm" @click="search") {{$t('search')}}
        b-col(style="text-align: right")
          b-btn(size="sm" @click="selectAdd") {{$t('dialogs_page.add_selection')}}
      b-card.table-card
        b-table(
          ref="userTable"
          :fields="tableData.fields"
          :items="fetchList"
          :key="tableData.key"
          :current-page="tableData.pagination.current"
          :per-page="tableData.pagination.limit"
          :empty-text="$t('no-content')"
          sort-by="name"
          tbody-class="lmm-table-body"
          show-empty
          responsive
        )
          //- body
          template(v-slot:head(check)="row")
            b-form-checkbox(v-model="allSelected" @change="selectAllRows" :indeterminate="isIndeterminate")
          
          template(v-slot:cell(check)="row")
            b-form-checkbox(v-model="row.item._isSelected", @change="handleCheck(row.item)")
          template(v-slot:cell(user_type)="row")
            span {{ memberType(row.item.user_type) }}

          template(v-slot:cell(member_type_id)="row")
            span(v-if="row.item.member_type_id === 1") {{$t('user')}}
            span(v-else-if="row.item.member_type_id === 2 || row.item.member_type_id === 3") {{$t('policy_manager')}}
            span(v-else-if="row.item.member_type_id === 6") {{$t('mid_manager')}}

        
      //- pagination
      .pagination-wrap
        div
          b-form-select(
            size="sm"
            v-model="tableData.pagination.limit"
            :options="tableData.pagination.perOptions"
          )
        b-pagination(
          size="sm"
          v-model="tableData.pagination.current"
          :total-rows="tableData.pagination.total"
          :per-page="tableData.pagination.limit"
          class="my-0 float-right"
        )

      .modal-footer
        b-button(size="sm" variant="secondary" @click="visible = false" pill) {{$t('close')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import { UsersAPI } from "@/api"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dialogs,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.tableData.pagination.search_key })
    },
    memberType() {
      return (value) => {
        if (value === 1) {
          return this.$t('user')
        } else if (value === 2) {
          return this.$t('policy_manager')
        } else if (value === 3) {
          return this.$t('policy_manager')
        } else if (value === 6) {
          return this.$t('mid_manager')
        } else {
          return "-"
        }
      }
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.visible = newVal
        this.tableData.pagination.context = this.data.context
        this.tableData.pagination.search_key = "name"
        this.tableData.pagination.search_value = ""
      },
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      checkedGroup: [],
      allSelected: false,
      isIndeterminate: false,

      visible: false,
      selectOptions: {
        list: [
          { value: "name", text: this.$t('account-manage'), type: "keyword" },
          { value: "mgrid", text: this.$t('ID'), type: "keyword" },
          { value: "part_name", text: this.$t("department"), type: "keyword" },
          {
            value: "member_type_id",
            text: this.$t('admin_privileges'),
            type: "select",
            list: [
              { value: "", text: this.$t('total') },
              { value: "3", text: this.$t('policy_manager') },
              { value: "6", text: this.$t('mid_manager') },
              { value: "1", text: this.$t('user') },
            ],
          },
        ],
      },
      tableData: {
        key: 0,
        fields: [
          {
            key: "check",
            label: "",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "part_name", label: this.$t('department'), thStyle: { minWidth: "100px" } },
          { key: "name", label: this.$t('name'), thStyle: { minWidth: "100px" } },
          { key: "mgrid", label: this.$t('ID'), thStyle: { minWidth: "100px" } },
          { key: "member_type_id", label: this.$t('permission'), thStyle: { minWidth: "100px" } },
        ],
        list: [],
        pagination: {
          by: "mgrid",
          limit: 10,
          offset: 0,
          order: "asc",

          search_key: "name",
          search_value: "",
          search_mode: "pagination",

          flag_servant: true,
          context: null,

          total: 1,
          current: 1,
          perOptions: [
            { value: 5, text: "5" },
            { value: 10, text: "10" },
            { value: 15, text: "15" },
          ],
        },
      },
    }
  },
  methods: {
    selectAdd() {
      if (this.checkedGroup.length === 0) {
        return this.$awn.warning(this.$t('dialogs_page.select_user_to_add'))
      }
      const selectedPk = this.tableData.list
        .filter(item => item._isSelected)
        .map(item => {
          return {
            pk: item.pk,
            mgrid: item.mgrid,
          }
        })
      this.$emit("select", selectedPk)
    },
    handleCheck(item) {
      if (this.checkedGroup.some(v => v.pk === item.pk)) {
        const index = this.checkedGroup.findIndex(u => u.pk === item.pk)
        this.checkedGroup.splice(index, 1)
      }
      if (item._isSelected) {
        this.checkedGroup.push(item)
      }

      if (this.checkedGroup.length == this.tableData.list.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v._isSelected = this.allSelected
        this.handleCheck(v)
      })

      if (this.checkedGroup.length == this.tableData.list.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },

    fetchList(ctx) {
      if (!ctx) return
      if (ctx.sortBy === "") return
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      // 그룹 사용자 추가
      if (this.tableData.pagination.context === "group_users_list_modal") {
        this.tableData.pagination.groupPk = this.data.groupData.pk
      }

      // 부서 사용자 추가
      if (this.tableData.pagination.context === "department_users_list_modal") {
        this.tableData.pagination.department_fk = this.data.department_fk
      }

      return UsersAPI.get("", { params: this.tableData.pagination }).then(resp => {
        this.allSelected = false
        this.tableData.list = resp.data.objects
        this.tableData.pagination.total = resp.data.meta.total_count

        return resp.data.objects
      })
    },
    changeSearchSelect(value) {
      const selected = _.find(this.selectOptions.list, { value })
      if (selected.type === "select") {
        this.tableData.pagination.search_value = selected.list[0].value
        this.search()
      } else {
        this.tableData.pagination.search_value = ""
      }
    },
    search() {
      this.tableData.pagination.current = 1
      this.tableData.key++
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .b-table {
  margin: 0;
  tr,
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  td {
    padding: 0 0 0 1rem;
    color: #6f6f6f;
    font-weight: 400;
    height: 40px;
  }
}
</style>
